/**
 * Core – Help, support, cases
 */

export default {
  help: {
    pageTitle: "Help Center",
    pageSubtitle: "Here you will find training videos of Lappa and you can get support from our manager",
    support: "Support",
    merch: "Merchants Questionnaire",
    licence: "Licence agreement",
    yourMess: "Your messages",
    goToSup: "Go to support messages",
    supportTeam: "Merchant support team",
    supportTeamDesc: "If you have any questions please contact us via",
    phone: "Phone",
    email: "Email",
    hours: "Office hours: weekdays 9am",
    fill: "Fill the subject",
    openCase: "Open case",
    pm: "Personal Manager",
    name: "Name",
    skype: "Skype",
  },
  supportMessages: {
    supportMess: "Support messages",
    support: "Support",
    caseNum: "Case number",
    desc: "Short description",
    status: "Status",
    dateUp: "Date updated",
    openCase: "Open case",
    info: "info",
    actionR: "action required",
    pendingLovat: "pending lappa action",
    answered: "answered",
  },
  dialog: {
    supportMess: "Support messages",
    case: "Case",
    info: "info",
    actionR: "action required",
    pendingLovat: "pending lappa action",
    answered: "answered",
    addFile: "Add file",
    addCommMess: "Please add a comment",
    addComm: "Add comment",
    chooseFiles: "Choose *jpg, *jpeg, *png files to upload",
  },
  case: {
    pageTitle: "New request",
    pageSubtitle: "We are here to help you",
    supportMess: "Support messages",
    openCase: "Open case",
    fillIn: "Please fill in your case",
    desc1:
      "To ensure prompt response, fill out the form completely and as accurately as possible.",
    desc2:
      "Lappa support team makes every effort possible to respond to customer issues in a timely manner.",
    caseGroup: "Case group",
    desc: "Short description",
    status: "Status",
    comments: "Comments",
    addFile: "Add file",
    chooseFiles: "Choose *jpg, *jpeg, *png files to upload",
    errFillCase: "Fill the case title",
    errFillDesc: "Fill the description",
    themes: {
      stores: "Stores",
      trans: "Transactions",
      vatRet: "VAT Returns",
      vatReg: "VAT Registration",
      documents: "Documents",
      taxAudit: "Tax Audit",
      other: "Other",
    },
    caseOpened: "Case has been opened",
  },
};
